var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVeloLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 26,
    viewBox: "0 0 88 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.31.46v25.08h15.947l1.855-4.103H29.82v-6.385h6.645l1.876-4.104H29.82V4.563h10.699L42.39.46H25.31zM62.053 13c0 7.196 5.736 13 12.848 13 7.08 0 12.849-5.804 12.849-13 0-7.163-5.769-13-12.849-13-7.112 0-12.848 5.837-12.848 13zm21.271 0c0 4.98-3.806 8.87-8.42 8.87s-8.458-3.89-8.458-8.87c0-4.94 3.844-8.87 8.458-8.87 4.614 0 8.42 3.93 8.42 8.87zM18.73.46l-7.092 15.542L4.545.46H0l11.637 25.5L23.275.46h-4.546zM60.8 25.54l1.892-4.139H50.26V.46h-4.51v25.08H60.8z",
    transform: "translate(-125.000000, -32.000000) translate(125.000000, 32.000000)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloLogo);
export default __webpack_public_path__ + "static/media/velo-logo.316a157ef6aabc109d29e52b6a9081f3.svg";
export { ForwardRef as ReactComponent };